import React from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { useHistory, Link } from 'react-router-dom';
import Logo from '../../assets/campusconectado.svg';
import api from '../../services/api';

export function HeaderAuth () {
  const history = useHistory();
  function handleLogout () {
    api.get('/sessions')
      .then(() => {
        localStorage.removeItem('logged');
        localStorage.removeItem('realm');
        history.go('/login');
      })
      .catch(() => {
        localStorage.removeItem('logged');
        localStorage.removeItem('realm');
        history.go('/login');
      });
  }

  return (
    <Navbar className="header-auth" bg="dark" variant="dark">
      <Navbar.Brand>
        <img src={Logo} height="40px" alt="" srcSet="" />
      </Navbar.Brand>
      <Nav className="mr-auto">
        <span className="nav-link text-bold"><Link className="link" to="/">Home</Link></span>
      </Nav>
      <div
        aria-hidden="true"
        className="text-bold btn-logout"
        onClick={handleLogout}
      >
        Sair
      </div>
    </Navbar>
  );
}
